import React, { useCallback } from "react";
import { ControlOutlined, LogoutOutlined } from "@ant-design/icons";
import { Avatar, Menu, Dropdown } from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import routes from "constants/routes";
import { useLogout } from "views/hooks";

const DropdownContent = styled.div`
  cursor: pointer;
  .username {
    margin-left: 8px;
  }
`;

const UserDropdown: React.FC = () => {
  const userInfo = useSelector((state: any) => state.user.userInfo);
  const history = useHistory();

  const handleLogout = useLogout();

  const handleMenuClick = useCallback(
    ({ key }) => {
      switch (key) {
        case "logout":
          handleLogout();
          return;
        case "admin":
          history.push(routes.ADMIN);
          return;
        default:
          return;
      }
    },
    [history, handleLogout]
  );
  const menuHeaderDropdown = (
    <Menu onClick={handleMenuClick}>
      {/* <Menu.Item key="center">
        <UserOutlined />
        个人中心
      </Menu.Item>

      <Menu.Item key="settings">
        <SettingOutlined />
        个人设置
      </Menu.Item>
      <Menu.Divider /> */}

      {userInfo.isAdmin && (
        <Menu.Item key="admin">
          <ControlOutlined />
          系统管理
        </Menu.Item>
      )}
      <Menu.Item key="logout">
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menuHeaderDropdown}>
      <DropdownContent>
        <Avatar size="small" alt="avatar">
          {userInfo.name}
        </Avatar>
        <span className="username">{userInfo.name}</span>
      </DropdownContent>
    </Dropdown>
  );
};

export default UserDropdown;
